export default {
    getStatusClass(status) {
        const statusMap = {
            Connected: 'success',
            Disconnected: 'danger',
        };

        return `badge-${statusMap[status]}`;
    },
};
